<template>
  <div class="my-service">
    <div class="service-content">
      <!--服务列表中的一个元素-->
      <my-card v-for="(item, index) in orderList" :key="index">
        <p slot="top">{{ item.orderNo }}</p>
        <p slot="middle">{{ `最早门店计费日期：${caclBeginTime(item.openTime, item.rentFreeDuration)}` }}</p>
        <div class="app-card-list" slot="bottom">
          <div class="card">
            <p>{{ item.num }}</p>
            <p>总入网名额</p>
          </div>
          <div class="card" @click="intoOperate(item)">
            <p>{{ item.num - item.surplusNum }}</p>
            <p>使用名额</p>
          </div>
          <div class="card">
            <p>{{ item.surplusNum }}</p>
            <p>剩余名额</p>
          </div>
        </div>
      </my-card>
    </div>
  </div>
</template>

<script>
  import MyCard from '../components/my-card';
  import moment from 'moment';
  import { mapMutations } from 'vuex';

  export default {
    name: 'my-service',
    components: {
      MyCard,
    },
    props: {
      orderList: {
        type: Array,
        default: () => []
      },
    },
    data () {
      return {

      }
    },
    methods: {
      intoOperate(data) {
        this.setCurrentOrder(data);
        this.$router.push({ path: `/operate/${data.id}` });
      },
      // 最早计费时间是开通时间减去免费使用时间
      caclBeginTime(openTime, rentFreeDuration) {
        return moment(openTime).add(rentFreeDuration, 'months').format('YYYY/MM/DD');
      },
      ...mapMutations(['setCurrentOrder'])
    }
  }
</script>

<style lang="scss" scoped>
  @import "common/sass/common.scss";

  * {
    box-sizing: border-box;
  }
  .my-service {
    text-align: left;
    padding:0px 10px 0 10px;
    h3 {
      font-size: 16px;
      font-weight: normal;
    }
    .service-content {
      margin-top: 10px;
      .card-padding {
        padding: 14px 15px 10px;
      }
      .apply-bottom {
        display: flex;
        justify-content: space-between;
      }
      .app-card-list {
        display: flex;
        flex-flow: row;
        background-color: $primary-color;
        font-size: 14px;
        margin-top: 10px;
        .card {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          flex-flow: column;
          flex: 1;
          &:active {
            background-color: $gray-color;
          }
          >p {
            margin-bottom: 10px;
          }
          img {
            width: 32px;
            height: 32px;
            font-size: 0;
          }
        }
      }
    }
    .apply-btn {
      padding: 0 15px;
    }
  }

</style>

